<template>
  <div class="flex items-center">
    <vs-avatar :src="'/img/avatar-s-3.7ed1da4a.jpg'" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" />
    <!-- <vs-avatar :src="params.data.logo" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" /> -->
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{ params.value }}</router-link>
  </div>
</template>

<script>
    export default {
        name: 'CellRendererLink',
        computed: {
          url() {
            return "/apps/partners/view/" + this.params.data.partid
          }
        }
    }
</script>
